import { BrowserRouter as Router } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Analytics } from '@vercel/analytics/react';
import { ScreenProvider } from './contexts/ScreenContext';
import { DemoContainer } from './components/DemoContainer';
import { ErrorBoundary } from './components/ErrorBoundary';
import screenGraphData from './data/screenGraph.json';
import { ScreenGraph } from './types';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScreenProvider screenGraph={screenGraphData as ScreenGraph}>
          <div className="min-h-screen bg-gray-50">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="min-h-screen"
            >
              <DemoContainer />
            </motion.div>
          </div>
        </ScreenProvider>
        <Analytics />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
